import { ACTION, SCREEN } from '../constants/mixpanel';

import useFeatureFlags from 'shared/modules/common/hooks/use-feature-flags';
import Mixpanel from 'shared/vendor/Mixpanel';

const FEATURE_NAME = 'feature.shopping';

export default function useIsShoppingEnabled() {
  const data = useFeatureFlags({
    onError: (error) => {
      Mixpanel.trackEvent(`${SCREEN.BROWSE} - ${ACTION.ERROR}`, {
        Error: error.message.toLowerCase(),
      });
    },
  });

  const isEnabled = data
    ? data.features.enabled.indexOf(FEATURE_NAME) > -1
    : false;

  return isEnabled;
}
